const empModulo = {
    agGrid: {
        paginacion: 15,
        id: 'myGrid',
        class: 'ag-theme-alpine mt-3',
        style: {
            width: '100%',
            height: '450px'
        }
    },
    agGridModal: {
        paginacion: 10,
        id: 'myGrid',
        class: 'ag-theme-alpine mt-3',
        style: {
            width: '100%',
            height: '450px'
        }
    },
    url: {
        seguridad: {
            recuperacion: 'usuario/account/reset-password/init',
            changeUser: 'usuario/account/change-password'
        },
        epp: {
            administrador:{
                //empresa
                getEmpresas: 'empresa',
                getEmpresaSolicita: 'empresa/grupo',
                articuloDotacion: 'articulo-dotacion/all',
                articuloParams: 'articulo-dotacion/',
                deleteArticulo: 'articulo-dotacion/eliminar/',
                updateArticulo: 'articulo-dotacion/modify?id=',//18&cantidad=16',
                //Cargos
                getCargos: 'caracteristica/cargo',
                postCargos: 'cargo',

                //Empleados
                findEmpleado:'empleado',
                //FindEmpleados Alternative
                findEmpleadoValidar:'empleado/valida',
                //validar solamente la cedula
                findCedulaValidar:'empleado/valida-only-cid',
                //Provincia
                getProvincias:'provincia',
                //Cantones
                getCantones:'canton/provincia',
                //Localidad
                getLocalidad:'caracteristica/localidad',
                //CodigoCostos
                getCodigoCosto:'caracteristica/ccosto',
                //DEPARTAMENTO
                getDepartamento:'caracteristica/departamento',
                //EmpleadosbyDep
                getEmployesByDepEmp:'empleado/depaEmpresa',
                //Reporte historico
                getReportUsers:'empleado/historico',
                //Reporte historico excel
                getReportusresExcel:'empleado/excelHistorico',
                //Reporte de empleados
                getReportEmploye:'empleado/report',
                //Rreporte de empleados Excel
                getReportEmployeExcel:'empleado/excel',
                //Usuarios que tienene para marcacion
                getUsuarioMarcacion:'empleado/empleado-requiere-marcacion',
                //subir archivo
                uploadFile: 'dotacion-colaborador/upload',
                //admin roles
                rolesDotacion: 'rol/dotacion',
                rolesDota: 'authority/dotacion',
                //controlPeronsa
                uploadfilePersonal: 'control-colaborador/upload',
                findPuntoEnPersonal: 'control-colaborador/find',
                deletePuntoPersonal: 'control-colaborador/delete-colab-pe/',
                //
                readDocument: 'empleado/readDocument',
                empleadoEmpresa: 'empleado/empresa/',//FABR,
                //
                getEmployesByDepEmpColaborador:'empleado/depaEmpresa/colaborador/',
                // getEmployesByDepEmpColaborador:'/empleado/depaEmpresa/',
                empleadoEmpresaColaborador: 'empleado/empresa/colaborador/',
                //
                updateType: 'empleado/update-type',
                updateEmpleadoCustom: 'empleado/custom',
                updateEmpleadoCustomList: 'empleado/custom/list',
                createHistorial: 'empleado/historial',
                createHistorialList: 'empleado/historial/lista',
                ///nomina/v1/api/empleado/sstma
                sstma: 'empleado/sstma',
                sstmaRechazado: 'empleado/sstma/rechazado',
                sstmaReporte: 'empleado/sstma/reporte',
                sstmaReportDownload: 'empleado/sstma/reporte/download',
                sstmaAprobado: 'empleado/sstma/aprovado/doc-iess',
                //https://apidev.lafabril.com.ec/app/ms/nomina/v1/api/empleado/sstma/aprovado/doc-iess
                anularHistorial: 'empleado/historico/inactivar',
                empresaNoCorporativos: 'empresa/no-grupo',
                empleadosByEmpresa: 'empleado/empresa/contratista',
                desvicularContratista: 'empleado/desvincular-contratista'



            },
            puntoEntrega:{
                requisicion: 'requisicion/find/',
                // postRequisicion: 'requisicion/save',
                postRequisicion: 'requisicion/save',
                //empleado
                getEmpleado: 'dotacion-colaborador/all',
                getEmpleadoParam: 'dotacion-colaborador/find?idArticulo=',//SEAB1&cedula=1312700337',
                updateEmpleado: 'dotacion-colaborador/edit',
                //colaborador
                inventarioArticulo: 'articulo-inventario/all',
                inventarioArticuloEpp: 'articulo-inventario/all-epp',
                getColaboradorTajeta: 'dotacion-colaborador/employe/',
                postEntrega: 'entrega-dotacion/insert',
                //reporte
                entregaDotacion:'entrega-dotacion/all',
                entregaDotacionParams: 'entrega-dotacion/find/',//entrega-dotacion/find/{desde}/{hasta}
                downloadDotacion: 'entrega-dotacion/download/',//{desde}/{hasta}'
                //tranferir
                transferir: 'transferir/insert',
                //user home
                userHome: 'punto-entrega/find-current'
            }  
        },
        seleccion: {
            //Campeones de Compromiso
            csvCampeones : "seleccion/upload/campeones/csv",
            saveCampeones: "seleccion/save/campeones/csv",
            csvEntrevistaSalidas  : "seleccion/upload/esalidas/csv",
            saveEntrevistaSalidas : "seleccion/save/esalidas/csv",
            csvSeleccionProcesos  : "seleccion/upload/procesos/csv",
            saveSeleccionProcesos : "seleccion/save/procesos/csv",
            csvSeleccionPromocion : "seleccion/upload/promocion/csv",
            saveSeleccionPromocion: "seleccion/save/promocion/csv",
            csvSeleccionCatalogos : "seleccion/upload/catalogos/csv",
            saveSeleccionCatalogos: "seleccion/save/catalogos/csv",
        }
    },
    button: {
        buttonsCss: {
            primary: 'btn btn-primary btn-block',
            secondary: 'btn btn-secondary btn-block',
            success: 'btn btn-success btn-block',
            danger: 'btn btn-danger btn-block',
            warning: 'btn btn-warning btn-block',
            info: 'btn btn-info btn-block',
            light: 'btn btn-light btn-block',
            dark: 'btn btn-dark btn-block',
            primaryOutline: 'btn btn-outline-primary',
            secondaryOutline: 'btn btn-outline-secondary',
            successOutline: 'btn btn-outline-success',
            dangerOutline: 'btn btn-outline-danger',
            warningOutline: 'btn btn-outline-warning',
            infoOutline: 'btn btn-outline-info',
            lightOutline: 'btn btn-outline-light',
            darkOutline: 'btn btn-outline-dark',
            primarylg: 'btn btn-primary btn-lg btn-block',
            successLg: 'btn btn-success btn-lg btn-block',
            dangerLg: 'btn btn-danger btn-lg btn-block',
            warningLg: 'btn btn-warning btn-lg btn-block',
            warningLgFile: 'btn btn-warning btn-lg btn-block btn-file',
        },
        buttonsNombre: {
            editar: 'Editar',
            ver: 'Ver',
            eliminar: 'Eliminar',
            agregar: 'Agregar ',
            guardar: 'Guardar',
            actualizar: 'Actualizar',
            mostrar: 'Mostrar seleccion',
            regresar: 'Regresar',
            continuar: 'Continuar',
            seleccionar: 'Seleccionar',
            procesar: 'Procesar',
            buscar: 'Buscar',
            sustento: 'Sustento',
            validar: 'Validar',
            descargar: 'Descargar',
            descargarRecibo: 'Descargar Recibo Cobros',
            descargarEstado: 'Descargar Estados Docs',
            detalle: 'Ver Ordenes',
            agregarProducto: 'Añadir Productos',
            anadirProducto: 'Añadir',
            limpiar: 'Eliminar todos los productos',
            anular: 'Anular',
            aprobar: 'Aprobar',
        }
    },
    mensajes: {
        errorServicio: 'error..!!',
        desabilitada: 'Opción desabilitada',
        eliminar: '¿Esta seguro que desea eliminar el siguiente elemento?',
        guardar: '¿Esta seguro que desea guardar?',
        actualizar: '¿Esta seguro que desea actualizar el siguiente elemento?',
        datoGuardado: 'Se guardo corectamente..!!',
        guardarParada: 'Esta seguro que desea registrar este evento..??',
        procesar: '¿Esta seguro que desea procesar el siguiente elemento?',
        validar: '¿Esta seguro que desea validar el siguiente elemento?',
        anticipo: 'Se tomara este valor como anticipo.',
        camposObligatorio: 'Los campos tipo transaccion y número documento deben estar llenos caso contrario se tomara como anticipo.',
        anular: 'Confirma que desea eliminar el registro seleccionado.',
    },
    colors: {
        verde: 'green',
        azul: 'blue',
        rojo: 'red'
    },
    imagenes: {
        regalo: '<span><img src="../../../assets/image/regalo.png" height="30" width="30"></i></span>',
        item: '<span><img src="../../../assets/image/regalo.png" height="30" width="30"></i></span>'
    },
    div: {
        resposiveFull: 'col-12 col-sm-6 col-md-6 col-lg-4 ',//verificar el tipo de pantalla
    }
}


export { empModulo }